import { LinearProgress, Grid } from "@mui/material";

const LoadingPageComponent = () => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "50vh" }}
    >
      <Grid size={12}>
        <LinearProgress color="secondary" />
      </Grid>
    </Grid>
  );
};

export default LoadingPageComponent;